import { Box } from '../../../primitives/Box/Box.es.js';
import 'react';
import '../../../primitives/Center/styled.es.js';
import { Group } from '../../../primitives/Group/Group.es.js';
import '../../../primitives/Grid/Grid.es.js';
import '../../../primitives/Level/Level.es.js';
import '../../../primitives/Shelf/Shelf.es.js';
import '../../../primitives/Portal/Portal.es.js';
import '../../../primitives/Hidden/Hidden.es.js';
import '../../../primitives/Media/Media.es.js';
import '../../../primitives/Dialog/Dialog.es.js';
import '../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../primitives/Popper/Popper.es.js';
import '../../../primitives/DragHandle/DragHandle.es.js';
import '../../../primitives/Pin/Pin.es.js';
import styled from 'styled-components';
import '../../../utils/assertions.es.js';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { spacing, radius } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';

const GroupWrapper = styled(Group)`
    line-height: 1;
    ${({ theme, dotSize }) => dotSize && `height: ${theme.spacing(dotSize)};`}
    ${({ theme, dotPosition, dotSize }) => dotSize && dotPosition === "inside" && `margin-top: -${theme.spacing(dotSize)};`}
`;
const GroupItem = styled(Group.Item)`
    position: relative;
    line-height: 1;
    height: 100%;
    width: ${spacing("md")};
`;
const DotWrapper = styled(Box)`
    position: absolute;
    top: 0;
    left: 0;
    justify-content: center;
    cursor: pointer;
    width: 100%;
    height: 100%;
`;
const AbsoluteBox = styled(Box)`
    position: absolute;
    top: 0;
    left: 0;
    top: calc(50% - ${spacing("md")} / 2);
    line-height: 1;
    width: ${spacing("md")};
    height: ${spacing("md")};
`;
const Circle = styled(Box)`
    width: 100%;
    height: 100%;
    border-radius: ${radius("round")};
`;
const Styled = {
  GroupWrapper,
  GroupItem,
  DotWrapper,
  AbsoluteBox,
  Circle
};

export { Styled as default };
//# sourceMappingURL=styled.es.js.map
